<template>
    <div>
       <div id="mainhold">
           <div id="topbuttons">
            <div id="fetchposts" class="btn2 bgPink cpointer"  @click="fetchNewPosts">FETCH POSTS TO MODERATE</div>
            <div id="fetchposts" class="btn2 bgMint cpointer"  @click="fetchAssignedPosts">ASSIGNED POSTS TO MODERATE</div>
           </div>
           <div id="allposts">
           <div v-for="(post, index) in posts" v-bind:key="index">
           <div class="postholder">
               <a v-bind:href="post.mainURL" rel="noreferrer" target="_blank"><div class="imageholder" @click="viewimage(post.mainURL)"><img :src="post.metaIMG" width="100%"></div></a>
                <div class="contentholder">
                <div class="typelabel textright">{{post.postType}}</div>
                <div class="comment">{{post.postText}}<br><br>Posted: {{post.post_date | moment('from', 'now')}}</div>
                <div id="approve" class="btn bgTeal cpointer" @click="approve(post)" v-if="!post.approved">APPROVE</div>
                <div id="deny" class="btn bgGreen cpointer" @click="deny(post)" v-if="!post.approved">DENY</div>
                </div>
               </div>
           </div>
           <div id="denied" v-if="denial">
               <div id="closeme" class="amTeallight" @click="closeDenial">close</div>
               <div id="denialoptions">
                   <div id="choose" class="amTealregular textcenter">Choose Review Reason</div>
                   <div id="notartwork" class="btn3 bgMint cpointer" v-show="postType == 'artwork'" @click="invalidArtwork">NOT ARTWORK</div>
                   <div id="notartwork" class="btn3 bgTeal cpointer" @click="didviolate">TERMS VIOLATION</div>
               </div>
           </div>
           </div>
       </div>
    </div>
</template>

<script>
import db from '../main'
import firebase from 'firebase/app'
import 'firebase/auth'
export default {
    name: "moderation",
    data(){
        return {
         didfetch: false,
         posts: [],
         userID: "",
         denial: false,
         transcript: "",
         reviewer: "",
         dimage: "",
         duid: "",
         ddoc: "",
         postType: "",
         amessage: "",
         notartwork: "Reviewed Artwork Post does not meet criteria",
         violation: "Post is pending removal for violation of Terms & Conditions",
        }
    },
    methods: {
        approve(post){
            db.collection("posts").doc(post.document_Id).update({
                "approval_state": "approved", "reviewedby":this.userID
            })
            post.approved = true
            
        },
        deny(post){
            this.denial = true
            this.ddoc = post.document_Id
            this.duid = post.user_Id
            this.dimage = post.metaIMG
            this.postType = post.postType
            post.approved = true
        },
        denied(){
            var posttime = new Date()
            db.collection("dm").doc("alerts").collection(this.duid).doc("alertNotice").set({"alert":true})
            db.collection("posts").doc(this.ddoc).update({"visible":false, "status":"pending_deletion", "approval_state": "denied", "reviewedby":this.userID})
            
            const ticket = db.collection("dm").doc("alerts").collection(this.duid).doc()
            ticket.set({
                alertStat: "open",
                alertAction: "true",
                alertDocID: ticket.id,
                alertMessage: this.amessage,
                alertTranscript: this.transcript,
                alertType: "Reported Post",
                post_date: parseInt(posttime/1000),
                alertImage: this.dimage,
                reviewer: this.reviewer,
                reportedPostID: this.ddoc,
                serverTime: new Date(),
            }).then(() => this.ddoc = "", this.duid = "", this.dimage = "", this.amessage = "", this.denial = false)
        },
        didviolate(){
            this.amessage = this.violation
            this.transcript = "Your post violates our Community Guidelines Sharing Policies. It has been flagged and removed from the feed. If you feel this was done in error, please respond with your case."
            this.denied()
        },
        invalidArtwork(){
            this.amessage = this.notartwork
            this.transcript = "The artwork you submitted does not meet our criteria for Artwork listings. Please repost as Artlife. This post has been removed from the feed."
            this.denied()
        },
        closeDenial(){
            this.denial = false
        },
        fetchNewPosts(){
            this.didfetch = true
            db.collection("posts").where("visible", "==", true).where("approval_state", '==', "pending_review").orderBy("serverTime", "desc").limit(50).get().then(snapshot =>{
            if (snapshot){
                const documents = snapshot.docs
                documents.forEach(async document =>{
                  const post = document.data()
                  post.approved = false
                  this.posts.push(post)

                    const makeme = db.collection("posts").doc("mod").collection("moderating").doc()
                    makeme.set({
                       modDoc: post.document_Id,
                       modID: this.userID,
                       modDate: new Date()  
                    })

                })
            }
        })
        },
        fetchAssignedPosts(){
            this.posts = []
            db.collection("posts").where("approval_state", '==', this.userID).where('visible', '==', true).orderBy("serverTime", "desc").get().then(snapshot =>{
            if (snapshot){
                const documents = snapshot.docs
                documents.forEach(document =>{
                  const post = document.data()
                  post.approved = false
                  this.posts.push(post)
                })
            }
        })
        }
    },
    created(){
        firebase.auth().onAuthStateChanged(user =>{
            if (user){
                this.userID = firebase.auth().currentUser.uid
                this.reviewer = firebase.auth().currentUser.displayName
                
            }
        })
    }
}
</script>

<style scoped>

#mainhold {
    width: 100%;
    height: 55vh;
    background-color: white;
    position: relative;
    overflow: scroll;
}

#denied {
    width: 100%;
    height: 50vh;
    background-color: rgb(205, 232, 229);
    position: absolute;
}

#allposts {
    width: 100%;
     page-break-inside: avoid;
      break-inside: avoid;
      break-before: avoid;
      break-after: avoid;
      column-count: 1;
      column-gap: 2%;
      flex-wrap: wrap;
}
.postholder {
    width: 32.27%;
    padding: 2%;
    height: 320px;
    float: left;
    clear: right;
    background-color: wheat;
    margin: .5%;
    position: relative;
    overflow: scroll;
}

#denialoptions {
    width: 100%;
    height: auto;
    padding: 5%;
}

.imageholder {
    width: 50%;
    height: auto;
    float: left;
    clear: right;
    padding: 3%;
}

.contentholder {
    width: 50%;
    height: auto;
    float: left;
    clear: right;
}

.typeLabel {
    width: 100%;
    height: 50px;
}

.comment {
    width: 100%;
    padding: 1%;
    font-family: 'cocomatpro-light';
    text-align: left;
    font-size: .75em;
    line-height: 1em;
    margin-bottom: 20px;
}

.textcenter {
    text-align: center;
}

.btn {
    width: 50%;
    height: 30px;
    padding: 3%;
    float: left;
    clear: right;
    font-size: .4em;
    line-height: 3em;
    color: white;
    margin-bottom: 10px;
}

.btn2 {
    width: 50%;
    height: 40px;
    padding: 3%;
    float: left;
    clear: right;
    font-size: 1em;
    line-height: .5em;
    color: white;
    margin-bottom: 10px;
}

.btn3 {
    width: 100%;
    height: 40px;
    padding: 3%;
    float: left;
    clear: right;
    font-size: 1em;
    line-height: .5em;
    color: white;
    margin-bottom: 10px;
}
</style>